import type { ChangeEvent } from 'react'

import cx from 'classnames'

import './styles.scss'

import { ErrorMessage } from '../ErrorMessage'

interface Props {
  label?: string
  value?: boolean
  disabled?: boolean
  errors?: Array<Record<string, unknown>>
  className?: string
  onChange: (v: boolean) => void
  labelClassName?: string
  round?: boolean
}

export function Checkbox ({
  label,
  value,
  disabled,
  errors,
  className,
  onChange,
  labelClassName,
  round
}: Props): JSX.Element {
  function handleOnChange (e: ChangeEvent<HTMLInputElement>): void {
    if (onChange) {
      onChange(e.target.checked)
    }
  }

  return (
    <div className={cx('nh-checkbox-wrapper', className)}>
      <div className='nh-checkbox'>
        <input
          className={cx({
            round
          })}
          tabIndex={-1}
          type='checkbox'
          checked={!!value}
          disabled={disabled}
          onChange={handleOnChange}
        />
        <label className={cx(labelClassName)}>
          {label}
        </label>
      </div>
      {errors && (
        <ErrorMessage errors={errors} />
      )}
    </div>
  )
}
